import React from "react";
// import "antd/dist/antd.css";
import { ConfigProvider } from "antd";

import "./App.css";
import "./themes/black-white-theme.css";
import "./themes/switch-override.css";
import AuthRoutes from "./routes/Auth";
import ErrorBoundary from './components/ErrorBoundary';

// Add this to src/App.js or create src/utils/resizeObserverErrorFix.js
const resizeObserverErrorHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    // Ignore this specific error
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider
        getPopupContainer={(node) => {
          if (node) {
            return node.parentNode;
          }
          return document.body;
        }}
      >
        <AuthRoutes />
      </ConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
